/**
 * Client: хоосон эсвэл буруу JSON-той хариунд унахгүй.
 */
export async function fetchJsonArray(url, fallback = []) {
  const safeFallback = Array.isArray(fallback) ? fallback : [];

  const pickArray = (value) => {
    if (Array.isArray(value)) return value;
    if (!value || typeof value !== "object") return null;

    // API wrapper-үүдийг дэмжинэ: { data: [...] }, { result: [...] }, { items: [...] }
    const candidates = [value.data, value.result, value.items, value.rows];
    for (const candidate of candidates) {
      if (Array.isArray(candidate)) return candidate;
    }

    return null;
  };

  try {
    const res = await fetch(url, { credentials: "include" });
    const text = await res.text();
    if (!text?.trim()) return safeFallback;

    const data = JSON.parse(text);
    const parsedArray = pickArray(data);
    return parsedArray ?? safeFallback;
  } catch {
    return safeFallback;
  }
}
